export default function colorDescriptionChange(colorName) {
  const selectors = {
    container: '[js-color-description="' + colorName + '"]',
  };

  if ($(selectors.container).length) {
    $(selectors.container)
      .addClass("is-selected")
      .siblings()
      .removeClass("is-selected");
  } else {
    $("[js-description-default]")
      .addClass("is-selected")
      .siblings()
      .removeClass("is-selected");
  }
}
